"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var message = {
  state: {
    ready: {
      type: null,
      date: new Date()
    }
  },
  mutations: {
    change: function change(state, type) {
      state.ready = type;
      console.dir(state);
    }
  },
  actions: {},
  getters: {}
};
exports.default = message;